module.exports = __webpack_public_path__ + "img/place27.175cc63e.jpg";